<template lang="pug">
    el-col(:span="19")
        div#D2(style="height: 350px; padding: 20px; padding-left: 80px").chart

</template>

<script>
var echarts = require("echarts");
import { getWidget } from "@/api/dashboard";
const id = "D2";
export default {
  name: id,
  async created() {
    const resp = await getWidget(id);
    const stats = resp.data.data.reverse();
    const days = stats.map(e => e.date);
    const counts = stats.map(e => e.count);
    // 每日订单走势
    const orderChart = echarts.init(document.getElementById("D2"));
    orderChart.setOption({
      title: { text: "7日订单" },
      tooltip: {
        show: true
      },
      legend: {
        data: ["订单数"],
        right: 1
      },
      yAxis: [
        {
          name: "订单数",
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#666",
            fontSize: 12
          }
        }
      ],
      xAxis: {
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#666",
          fontSize: 12,
          margin: 12
        },
        data: days
      },
      series: [
        {
          name: "订单数",
          yAxisIndex: 0,
          data: counts,
          type: "bar",
          color: "#00B5FF",
          barWidth: 30
        }
      ]
    });
  }
};
</script>

<style lang="scss" scoped>
.chart {
  height: 400px;
  padding: 30px;
}
</style>
